import {Injectable} from '@angular/core';
import {UsersService} from '../api/services/users.service';
import {MessagingWhatsAppTemplateService as TemplatesApiService} from '../api/services/messaging-whats-app-template.service';
import {
  LookupModel,
  WhatsAppMessagingTemplateModel,
  WhatsAppTemplateListRequest,
  WhatsAppTemplateListResponse
} from '../api/models';
import {AdvancedMessagingService as ApiAdvancedMessagingService} from '../api/services/advanced-messaging.service';
import {PhoneNumbersUtils} from '../core/utilities/phone-numbers-helpers';

@Injectable()
export class ProMessagingWhatsAppTemplateService {

  templateStatuses: Array<LookupModel> = [
    {id: 'APPROVED', text: 'Approved'},
    {id: 'IN_APPEAL', text: 'In Appeal'},
    {id: 'PENDING', text: 'Pending'},
    {id: 'REJECTED', text: 'Rejected'},
    {id: 'PENDING_DELETION', text: 'Pending Deletion'},
    {id: 'DELETED', text: 'Deleted'},
    {id: 'DISABLED', text: 'Disabled'},
    {id: 'PAUSED', text: 'Paused'},
    {id: 'LIMIT_EXCEEDED', text: 'Limit Exceeded'},
  ];

  templateCategories: Array<LookupModel> = [
    {id: 'TRANSACTIONAL', text: 'Transactional'},
    {id: 'MARKETING', text: 'Marketing'},
    {id: 'ACCOUNT_UPDATE', text: 'Account Update'},
    {id: 'PAYMENT_UPDATE', text: 'Payment Update'},
    {id: 'PERSONAL_FINANCE_UPDATE', text: 'Personal Finance Update'},
    {id: 'SHIPPING_UPDATE', text: 'Shipping Update'},
    {id: 'RESERVATION_UPDATE', text: 'Reservation Update'},
    {id: 'ISSUE_RESOLUTION', text: 'Issue Resolution'},
    {id: 'APPOINTMENT_UPDATE', text: 'Appointment Update'},
    {id: 'TRANSPORTATION_UPDATE', text: 'Transportation Update'},
    {id: 'TICKET_UPDATE', text: 'Ticket Update'},
    {id: 'ALERT_UPDATE', text: 'Alert Update'},
    {id: 'AUTO_REPLY', text: 'Auto Reply'},
    {id: 'OTP', text: 'OTP'},
    {id: 'UTILITY', text: 'Utility'},
    {id: 'AUTHENTICATION', text: 'Authentication'},
  ];

  templateCategoriesRestricted: Array<LookupModel> = [
    {id: 'MARKETING', text: 'Marketing'},
    {id: 'UTILITY', text: 'Utility'},
    {id: 'AUTHENTICATION', text: 'Authentication'},
  ];


  templateHeaderFormats: Array<LookupModel> = [
    {id: 'NONE', text: 'None'},
    {id: 'TEXT', text: 'Text'},
    {id: 'IMAGE', text: 'Image'},
    {id: 'VIDEO', text: 'Video'},
    {id: 'DOCUMENT', text: 'Document'},
  ];

  templateButtonTypes: Array<LookupModel> = [
    {id: 'NONE', text: 'None'},
    {id: 'QUICK_REPLY', text: 'Quick Reply'},
    {id: 'QUICK_ACTION', text: 'Quick Action'},
  ];

  templateButtonActionTypes: Array<LookupModel> = [
    {id: 'URL', text: 'Link'},
    {id: 'PHONE_NUMBER', text: 'Phone Number'},
  ];

  constructor(private apiUserService: UsersService,
              private apiTemplateService: TemplatesApiService,
              private apiMessagingService: ApiAdvancedMessagingService,
  ) {

  }

  async getWhatsAppNumbers(): Promise<LookupModel[]> {
    const messagingNumbers = await this.apiMessagingService.proMessagingGetMyMessagingPhoneNumbers().toPromise();
    const whatsAppNumbers = messagingNumbers.filter(x => x.wabaDid)

    return whatsAppNumbers.map<LookupModel>(x => {
      return {
        id: x.wabaId,
        text: PhoneNumbersUtils.format(x.phoneNumber)
      }
    })
  }

  public async getTemplateListResponse(state: WhatsAppTemplateListRequest): Promise<WhatsAppTemplateListResponse> {
    console.log(state);
    return await this.apiTemplateService.messagingWhatsAppTemplateGetList({
      body: state,
    }).toPromise();
  }

  public async getTemplateById(id: string): Promise<WhatsAppMessagingTemplateModel> {
    return await this.apiTemplateService.messagingWhatsAppTemplateGetTemplateById({
      id: id,
    }).toPromise();
  }

  public async saveTemplate(model: WhatsAppMessagingTemplateModel): Promise<boolean> {
    await this.apiTemplateService.messagingWhatsAppTemplateSaveTemplate({
      body: model
    }).toPromise();

    return true;
  }

  public async deleteTemplateById(id: string): Promise<boolean> {
    await this.apiTemplateService.messagingWhatsAppTemplateDeleteTemplateById({
      id,
    }).toPromise();

    return true;
  }
}
